import React from "react";
import { Button } from "newui/components/Button";
import { CompactTextInput } from "newui/components/ui/InputWithLabel";

interface ComplianceQuestionsAddBarProps {
	value: string;
	isLoading: boolean;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	onAdd: () => void;
}

export const ComplianceQuestionsAddBar = ({
	value,
	isLoading,
	onChange,
	onKeyDown,
	onAdd,
}: ComplianceQuestionsAddBarProps) => {
	return (
		<div className="mt-4 flex items-center gap-3">
			<div className="min-w-0 flex-1">
				<CompactTextInput
					value={value}
					placeholder="Type your compliance question here to add it..."
					data-testid="compliance-question-add-input"
					onChange={onChange}
					onKeyDown={onKeyDown}
				/>
			</div>
			<Button
				btntype="primary"
				isLoading={isLoading}
				disabled={value.trim().length === 0}
				onClick={onAdd}
				data-testid="compliance-question-add-btn"
			>
				Add question
			</Button>
		</div>
	);
};
